import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';

const QuickActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const actions = [
    {
      label: 'Pause All Queues',
      icon: 'Pause',
      onClick: () => {
        console.log('Pausing all queues');
        setIsOpen(false);
      },
    },
    {
      label: 'Acknowledge Alerts',
      icon: 'CheckCircle',
      onClick: () => {
        console.log('Acknowledging alerts');
        setIsOpen(false);
      },
    },
    {
      label: 'Refresh Data',
      icon: 'RefreshCw',
      onClick: () => {
        console.log('Refreshing data');
        setIsOpen(false);
      },
    },
    {
      label: 'Export Report',
      icon: 'Download',
      onClick: () => {
        console.log('Exporting report');
        setIsOpen(false);
      },
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event?.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  return (
    <div className="quick-actions" ref={menuRef}>
      <div className={`quick-actions-menu ${isOpen ? '' : 'closed'}`}>
        {actions?.map((action, index) => (
          <div
            key={index}
            className="quick-actions-item"
            onClick={action?.onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e?.key === 'Enter' || e?.key === ' ') {
                e?.preventDefault();
                action?.onClick();
              }
            }}
          >
            <Icon name={action?.icon} size={20} />
            <span className="text-sm font-medium">{action?.label}</span>
          </div>
        ))}
      </div>
      <button
        className="quick-actions-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Quick actions menu"
        aria-expanded={isOpen}
      >
        <Icon name={isOpen ? 'X' : 'Zap'} size={24} />
      </button>
    </div>
  );
};

export default QuickActions;